import React, { ComponentClass, FC, ReactNode } from 'react'

import { useP360Access } from 'partner360/hooks/access/useP360Access'

type Options = {
  overlayPlaceholder?: ReactNode
}

export function withUserAccessCheck<P extends object>(
  Component: FC<P> | ComponentClass<P>,
  { overlayPlaceholder }: Options = {}
): FC<P> {
  return (props) => {
    const { isAccessDenied } = useP360Access()
    if (isAccessDenied) {
      return overlayPlaceholder ? <>{overlayPlaceholder}</> : null
    }

    return <Component {...props} />
  }
}
